<script setup>
defineProps({
    isLoading: {
        type: Boolean,
        default: false
    },
    canSave: {
        type: Boolean,
        default: false
    },
    customCss: {
        type: String,
        default: ''
    }
});
</script>

<template>
    <button
        aria-label="button"
        class="flex flex-row justify-center border border-transparent text-sm font-medium text-white shadow-xs"
        :class="[
            customCss,
            { 'rounded-md py-2 px-4 mb-2 w-full min-w-[88px] bg-green-400 hover:bg-green-500': !customCss },
            { 'opacity-25 cursor-not-allowed': !canSave || isLoading }
        ]"
        :disabled="!canSave || isLoading">
        <svg v-show="isLoading" class="w-5 h-5 text-white animate-spin" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
            <path
                class="opacity-75"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                fill="currentColor" />
        </svg>
        <div v-show="!isLoading" class="flex flex-row">
            <slot />
        </div>
    </button>
</template>
